import React from 'react';

const NotFound = () => {
    return (
        <div>Página no encontrada</div>
    )
}

export default NotFound;